import { IApplicationState } from '../../types/redux';

export function getResidentialComplexes(state: IApplicationState) {
  return state.residentialComplexes;
}
